const ENUM_TYPE_CHECKLIST = {
	CREATE: 1,
	READ: 2,
	UPDATE: 3,
	VIEW: 4,
	QUEUED: 5,
};

export default ENUM_TYPE_CHECKLIST;
